import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { OrganizationsRolesData } from 'src/app/modules/user-profile/models/organizations-role';
import { UserOrganizations } from 'src/app/modules/user-profile/models/user-organizations';
import { ArmDatService } from 'src/app/modules/user-profile/services/arm-data-service';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-organization-role-management',
    templateUrl: './organization-role-management.component.html',
    styleUrls: [
        // '../../../../../../../../src/assets/css/ds-core.css',
        // '../../../../../../../../src/assets/css/ds-button.css',
        // '../../../../../../../../src/assets/css/ds-card.css',
        // '../../../../../../../../src/assets/css/ds-form.css',
        // '../../../../../../../../src/assets/css/ds-modal.css',
        // '../../../../../../../../src/assets/css/ds-step-indicator.css',
        // '../../../../../../../../src/assets/css/ds-tabs.css',
        // '../../../../../../../../src/assets/css/ds-tile.css',
        './organization-role-management.component.css',
    ],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [
    NgxSpinnerModule,
    FormsModule,
    RouterLinkActive
]
})
export class OrganizationRoleManagementComponent implements OnInit {
  private armService = inject(ArmDatService);
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router);

  organizationsRoles: OrganizationsRolesData;
  selectedOrganization: any;
  orgNameObj: any;
  userRoleObj: any;
  routeFlag = false;
  systemResponse = [];

  ngOnInit(): void {
    this.routeFlag = false;
    this.organizationRoles();
  }

  organizationRoles() {
    this.spinner.show();
    this.armService.organizatationRoles$().subscribe(
      (organizationsRolesData: OrganizationsRolesData) => {
        this.spinner.hide();
        this.organizationsRoles = organizationsRolesData;
        sessionStorage.setItem(
          'orgKey',
          organizationsRolesData?.selectedOrgKey.toString()
        );
        this.selectedOrganization = organizationsRolesData?.userOrgs[0]?.orgKey;
        this.orgNameObj = organizationsRolesData?.userOrgs.filter(
          (roles: UserOrganizations) =>
            roles.orgKey == this.selectedOrganization
        );
        this.organizationRolesResponse(this.selectedOrganization.toString());
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  organizationRolesResponse(selectedOrganization: string) {
    this.spinner.show();

    this.armService.organizatationRolesByKey$(selectedOrganization).subscribe(
      (res) => {
        this.spinner.hide();
        this.userRoleObj = res;

        this.orgSystemApp(selectedOrganization);
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  orgSystemApp(selectedOrganization: string) {
    this.spinner.show();
    this.armService.orgSystemApplications$(selectedOrganization).subscribe(
      (res: any) => {
        this.systemResponse = res;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  OnChangeorganizationDropdown(orgKey) {
    this.organizationRolesResponse(orgKey);
    this.orgNameObj = this.organizationsRoles?.userOrgs.filter(
      (roles: UserOrganizations) => roles.orgKey == this.selectedOrganization
    );
  }

  navigateURl(systemApp) {
    sessionStorage.setItem('systemKeyRoles', systemApp.system.systemKey);
    sessionStorage.setItem('systemKey', systemApp.system.systemKey);
    sessionStorage.setItem('systemName', systemApp.system.systemName);
    this.router.navigateByUrl(
      `user-profile/account/account-details/role-permission`
    );
  }
}
